export default __webpack_public_path__ + "036d0a56b4a024bf807782b8c6b31d8c.png";